import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { FormModule } from '@portal-core/general/components/form/form.module';
import { SftpFormComponent } from '@portal-core/licenses/components/license-connectors/sftp-form/sftp-form.component';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';

@NgModule({
  declarations: [
    SftpFormComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ReactiveFormsModule,
    FormControlErrorMessageModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    FormModule
  ],
  exports: [
    SftpFormComponent
  ]
})
export class SftpFormModule { }
